import { blobClass } from "./blobs.css"

export function Blobs() {
  return (
    <>
      <Blob class={blobClass({ color: "indigo" })} />
      <Blob class={blobClass({ color: "rose" })} />
      <Blob class={blobClass({ color: "amber" })} />
      <Blob class={blobClass({ color: "orange" })} />
      <Blob class={blobClass({ color: "emerald" })} />
    </>
  )
}

function Blob(props: { class: string }) {
  return (
    <svg
      class={props.class}
      width="1330"
      height="1057"
      viewBox="0 0 1330 1057"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1297.02 728.417c114.25-401.969-75.29-569.171-486.577-686.071C399.151-74.554 95.555 57.493 19.624 365.349-65.269 709.543 138.48 909.127 532.27 1021.05c294.078 83.59 672.851 30.68 764.751-292.633" />
    </svg>
  )
}
